import StepLineChart from "../ComplaintCharts/StepLineGraph";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const resolution_count = async (body) => {
  try {
    const res = await axInst.post("complaints/resolution_count", body);
    const data = res.data;

    // console.log("Response data:", data);

    const openCountData =
      data.Total_Resolution_Count.Total_Resolution_Open_count || [];
    const closeCountData =
      data.Total_Resolution_Count.Total_Resolution_Close_count || [];

    const openCounts = openCountData.map((item) => item.Count.value);
    const closeCounts = closeCountData.map((item) => item.Count.value);
    const dates = openCountData.map((item) =>
      new Date(item.key_as_string).getDate()
    );

    return { openCounts, closeCounts, dates };
  } catch (error) {
    console.error("Error in resolution_count:", error);
    return { openCounts: [], closeCounts: [], dates: [] };
  }
};
export const ResolutionCount = () => {
  const { data, submitted } = useSelector((e) => e.filtersComplaint);

  const {
    data: chartData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["count", submitted],
    queryFn: () => resolution_count(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const isEmptyData =
    !chartData ||
    (chartData.openCounts.length === 0 &&
      chartData.closeCounts.length === 0 &&
      chartData.dates.length === 0);

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && isEmptyData && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      )}
      {!isFetching && !isError && !isEmptyData && chartData && (
        <div>
          <StepLineChart data={chartData} />
        </div>
      )}
    </div>
  );
};
